import { render, staticRenderFns } from "./ChallengeHomePage.vue?vue&type=template&id=64672a7c&scoped=true"
import script from "./ChallengeHomePage.vue?vue&type=script&lang=js"
export * from "./ChallengeHomePage.vue?vue&type=script&lang=js"
import style0 from "./ChallengeHomePage.vue?vue&type=style&index=0&id=64672a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64672a7c",
  null
  
)

export default component.exports